import { bootstrapApplication } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { configureFirebase, splashDidHide, splashWillHold } from '@huddle-sports-platform/app-core';
import { initTheme } from '@huddle-sports-platform/ui';

import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

configureFirebase(environment); // the ONE Firebase bootstrap - before anything injects
initTheme({ keyboard: Keyboard }); // stored theme before first paint - no flash of the wrong theme

/** The splash's minimum time on screen; the launch never feels shorter. */
const SPLASH_MINIMUM_MS = 2000;
const launchedAt = Date.now();

// Native: the splash is up - the boot gate veil knows it is covered (a warm
// boot drops it instantly, unseen) and the header mark's build entrance
// waits for the reveal.
if (Capacitor.isNativePlatform()) splashWillHold();

bootstrapApplication(App, appConfig)
  .then(() => {
    // The native splash holds (SplashScreen.launchAutoHide: false in
    // capacitor.config.ts) until the first themed frame - the boot gate
    // veil - has rendered, so the lockup dissolves straight into the app
    // with no unpainted gap. It also holds a MINIMUM beat - the lockup is
    // a brand moment, not a loading flicker - measured from script start,
    // so the floor only pads launches that would have been shorter.
    // Lazy import: a web no-op, like haptics.
    if (Capacitor.isNativePlatform()) {
      const remaining = Math.max(0, SPLASH_MINIMUM_MS - (Date.now() - launchedAt));
      setTimeout(() => {
        void import('@capacitor/splash-screen').then(({ SplashScreen }) =>
          // Flip splashHidden only once the splash is actually gone: the
          // header mark's entrance plays at reveal, and the boot gate veil
          // stops treating itself as covered.
          SplashScreen.hide().then(() => splashDidHide()),
        );
      }, remaining);
    }
  })
  .catch((err) => console.error(err));
